
export type GetProjectsType = typeof GetProjectsType[keyof typeof GetProjectsType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProjectsType = {
  FOR_YOU: 'FOR_YOU',
  USER: 'USER',
  FOLLOW: 'FOLLOW',
  DETAIL: 'DETAIL',
} as const;
